// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ymaps-2-1-79-default-cluster{display:flex;align-items:center;justify-content:center}.ymaps-2-1-79-default-cluster>*{color:#fff;font-weight:700;font-family:Golos UI;font-size:24px;line-height:28px}.ymaps-2-1-79-float-button{display:none!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
